var map = {
	"./demos/basic/index.ts": 93676,
	"./demos/custom/index.ts": 15454,
	"./demos/label/index.ts": 42895,
	"./demos/layout/index.ts": 75811,
	"./demos/remote/index.ts": 59929,
	"./demos/variable/index.ts": 16461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98161;